export const bmwAngledView =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Half+Size/BMW+Angled+View+Half+Cropped+V2.png';

export const bmwBackTop =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Half+Size/BMW+Back+Top+half.png';

export const bmwBack =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Half+Size/BMW+Back+half.png';

export const bmwFront =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Half+Size/BMW+Front+half.png';

export const bmwSideViewLeft =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Half+Size/BMW+Side+View+Left+half.png';

export const bmwSideViewRight =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Half+Size/BMW+Side+View+Right+half.png';

export const dodgeSideViewLeft =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/Toronto/Uber/Dodge+Side+View+Left+half.png';

export const bmwTopViewNoShadow =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Half+Size/BMW+Top+View+no+shadow+half.png';

export const dodgeTopViewNoShadow =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/DodgeHalfSize/Dodge+Top+View+no+shadow+half.png';

export const bmwCloseup =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Half+Size/BMW+closeup+half.png';

export const bmwTopArrows =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Mobile/pro_top--arrows.png';

export const dodgeTopArrows =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/LandingPage/Mobile/plus_top--arrows.png';



// WEBPACK FOOTER //
// ./src/images/landingLinks.js